import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {Col, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import MandatoryInput from '../../common/components/layout/MandatoryInput';
import LoginButton from '../../common/components/LoginButton';
import {LoginBackButton} from '../../common/components/StyledComp';
import {CIVILITIES} from '../../common/constants';

const Select = styled.select`
  -webkit-appearance: button;
  -webkit-padding-end: 20px;
  -webkit-padding-start: 2px;
  -webkit-user-select: none;
  background-color: transparent;
  position: relative;
  z-index: 2;
  width: 70px;
  border-color: gray;
  padding-left: 15px;
  margin: 0 10px 0 0;
`;

const CustomIcon = styled(FontAwesomeIcon).attrs({
  className: 'fa-w-14',
})`
  &&& {
    position: absolute;
    z-index: 2;
    width: 0.7em;
    right: 30px;
    top: 34px;
  }
`;

const AttributeDiv = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
  font-size: 12px;
`;

const RegisterStep1 = props => {
  const {t, newUser, setNewUser, submitted, setSubmitted, setStep, registerError} = props;

  const civilitiesList = CIVILITIES.length > 0
    && CIVILITIES.map((item, i) => {
      return (
        <option value={item} key={i}>{t('reg.form.field.civility.' + item)}</option>
      );
    }, this);

  return (
    <Row>
      <Col xs={{span: 10, offset: 1}}>
        <Row className="spaced-input">
          <Col xs={12}>
            <label>
              <AttributeDiv className="label-name">{t('reg.form.field.civility.label')}</AttributeDiv>

              <Select onChange={(e => setNewUser({...newUser, civility: e.target.value}))}>
                {civilitiesList}
              </Select>
              <CustomIcon icon={faChevronDown} color={'black'} />
            </label>
          </Col>
        </Row>
        <Row className="spaced-input">
          <MandatoryInput
            name="firstName"
            type="text"
            title={t('reg.form.field.firstname')}
            value={newUser.firstName}
            onChange={(name, text) => setNewUser({...newUser, firstName: text})}
            show={submitted && newUser.firstName === ''}
            customText={registerError ? ' ' : null}
          />
        </Row>
        <Row className="spaced-input">
          <MandatoryInput
            name="lastName"
            type="text"
            title={t('reg.form.field.lastname')}
            value={newUser.lastName}
            onChange={(name, text) => setNewUser({...newUser, lastName: text})}
            show={submitted && newUser.lastName === ''}
            customText={registerError ? ' ' : null}
          />
        </Row>
        <Row className="spaced-input">
          <MandatoryInput
            name="birthDate"
            type="date"
            title={t('reg.form.field.birthdate')}
            value={newUser.birthDate}
            onChange={(name, text) => {
              setNewUser({...newUser, birthDate: text});
            }}
            show={submitted && newUser.birthDate === ''}
            customText={registerError ? ' ' : null}
          />
        </Row>
        <Row className="spaced-input">
          <MandatoryInput
            name="postalCode"
            type="text"
            title={t('reg.form.field.postalCode')}
            value={newUser.postalCode}
            onChange={(name, text) => setNewUser({...newUser, postalCode: text})}
            show={submitted && newUser.postalCode === ''}
            customText={registerError ? ' ' : null}
          />
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <LoginBackButton onClick={() => {
              setStep(1);
              setSubmitted(false);
            }}>
              <Link to="/login" className="button-link d-flex align-items-center justify-content-center">
                {t('reg.back')}
              </Link>
            </LoginBackButton>
          </Col>
          <Col xs={12} sm={6}>
            <LoginButton onClick={() => {
              setSubmitted(true);
              if (newUser.firstName !== '' && newUser.lastName !== '' && newUser.birthDate !== '' && newUser.postalCode !== '') {
                setStep(2);
                setSubmitted(false);
              }
            }}>
              {t('reg.form.btnNext')}
            </LoginButton>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

RegisterStep1.propTypes = {
  t: PropTypes.func.isRequired,
  newUser: PropTypes.object.isRequired,
  setNewUser: PropTypes.func.isRequired,
  submitted: PropTypes.bool.isRequired,
  setSubmitted: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  registerError: PropTypes.object,
};

export default withTranslation('login')(RegisterStep1);
